<div id="utf-registration-verify-form">
  <div id="utf-registration-verify" class="row no-gutters">
    <div class="col-12 heading">
      <h2>{{cfetLabels.utf_registration_verify.heading}}</h2>
    </div>

    <div class="col-12 subheading">
      <p id="info" [innerHTML]="cfetLabels.utf_registration_verify.subheading"></p>
    </div>
    <hr>
    <div class="col-12 btn-container">
      <button tabindex="0" type="button" id="btn-signup" class="btn" (click)="newSignup($event)"
        (keyup)="newSignup($event)">
        {{cfetLabels.utf_registration_verify.button_label2}}</button>
      <button type="button" id="btn-signin" class="btn btn-alt btn-medium" tabindex="0" (click)="attSignin($event)">
        {{cfetLabels.utf_registration_verify.button_label1}}</button>
    </div>

  </div>
</div>